/*==============================================================================
TRESTLE
PUBLIC LANDING PAGE

Brand        : Diafemme
File         : TRESTLE_LANDING.js
Version      : 2.0

Responsibilities
----------------
• Initialize both TRESTLE Landing sections
• Smooth-scroll internal navigation
• Handle FAQ accordion
• Preserve accessible expanded/collapsed states
• Work across:
  - TRESTLE_LANDING.liquid
  - TRESTLE_LANDING_CLOSE.liquid
• Leave TRESTLE Journey controls to TRESTLE_Journey.js
==============================================================================*/

(() => {

"use strict";


/*==============================================================================
STATE
==============================================================================*/

const State = {

  initialized:false

};


/*==============================================================================
INITIALIZE
==============================================================================*/

function initialize(){

  if(State.initialized){
    return;
  }


  const hasLanding =
    document.querySelector(
      ".tr-landing"
    );


  if(!hasLanding){
    return;
  }


  State.initialized = true;


  bindSmoothScroll();

  bindFAQ();


  console.info(
    "TRESTLE Landing Ready"
  );

}


/*==============================================================================
SMOOTH SCROLL
==============================================================================*/

function bindSmoothScroll(){

  const links =
    document.querySelectorAll(
      "[data-tr-scroll]"
    );


  if(!links.length){
    return;
  }


  links.forEach(link => {

    link.addEventListener(
      "click",
      handleSmoothScroll
    );

  });

}


/*==============================================================================
HANDLE SMOOTH SCROLL
==============================================================================*/

function handleSmoothScroll(event){

  const link =
    event.currentTarget;


  const href =
    cleanString(
      link.getAttribute(
        "href"
      )
    );


  if(
    !href ||
    href === "#" ||
    !href.startsWith("#")
  ){
    return;
  }


  const targetId =
    href.slice(1);


  const target =
    document.getElementById(
      targetId
    );


  if(!target){
    return;
  }


  event.preventDefault();


  scrollToElement(
    target
  );

}


/*==============================================================================
SCROLL TO ELEMENT
==============================================================================*/

function scrollToElement(target){

  if(!target){
    return;
  }


  const offset =
    getHeaderOffset();


  const top =
    target.getBoundingClientRect().top +
    window.pageYOffset -
    offset;


  window.scrollTo({

    top:
      Math.max(
        0,
        top
      ),

    behavior:
      prefersReducedMotion()
        ?
        "auto"
        :
        "smooth"

  });

}


/*==============================================================================
HEADER OFFSET
==============================================================================*/

function getHeaderOffset(){

  const selectors = [

    "sticky-header",

    ".header-wrapper",

    ".shopify-section-header",

    "header"

  ];


  for(
    const selector
    of selectors
  ){

    const element =
      document.querySelector(
        selector
      );


    if(
      element &&
      isVisible(
        element
      )
    ){

      const height =
        element
          .getBoundingClientRect()
          .height;


      if(height > 0){

        return (
          Math.round(
            height
          ) +
          18
        );

      }

    }

  }


  return 100;

}


/*==============================================================================
FAQ
==============================================================================*/

function bindFAQ(){

  const buttons =
    document.querySelectorAll(
      ".tr-landing-faq-question"
    );


  if(!buttons.length){
    return;
  }


  buttons.forEach(button => {

    button.addEventListener(
      "click",
      handleFAQClick
    );

  });

}


/*==============================================================================
HANDLE FAQ CLICK
==============================================================================*/

function handleFAQClick(event){

  const button =
    event.currentTarget;


  const item =
    button.closest(
      ".tr-landing-faq-item"
    );


  if(!item){
    return;
  }


  const answer =
    item.querySelector(
      ".tr-landing-faq-answer"
    );


  if(!answer){
    return;
  }


  const expanded =
    button.getAttribute(
      "aria-expanded"
    ) === "true";


  closeOtherFAQs(
    item
  );


  if(expanded){

    closeFAQ(
      button,
      answer
    );

  }

  else{

    openFAQ(
      button,
      answer
    );

  }

}


/*==============================================================================
OPEN FAQ
==============================================================================*/

function openFAQ(
  button,
  answer
){

  button.setAttribute(
    "aria-expanded",
    "true"
  );


  answer.hidden =
    false;


  const icon =
    button.querySelector(
      "i"
    );


  if(icon){

    icon.textContent =
      "−";

  }

}


/*==============================================================================
CLOSE FAQ
==============================================================================*/

function closeFAQ(
  button,
  answer
){

  button.setAttribute(
    "aria-expanded",
    "false"
  );


  answer.hidden =
    true;


  const icon =
    button.querySelector(
      "i"
    );


  if(icon){

    icon.textContent =
      "+";

  }

}


/*==============================================================================
CLOSE OTHER FAQ ITEMS
==============================================================================*/

function closeOtherFAQs(
  currentItem
){

  const buttons =
    document.querySelectorAll(
      ".tr-landing-faq-question"
    );


  buttons.forEach(button => {

    const item =
      button.closest(
        ".tr-landing-faq-item"
      );


    if(
      !item ||
      item === currentItem
    ){
      return;
    }


    const answer =
      item.querySelector(
        ".tr-landing-faq-answer"
      );


    if(!answer){
      return;
    }


    closeFAQ(
      button,
      answer
    );

  });

}


/*==============================================================================
VISIBILITY
==============================================================================*/

function isVisible(element){

  if(!element){
    return false;
  }


  const style =
    window.getComputedStyle(
      element
    );


  return (
    style.display !== "none" &&
    style.visibility !== "hidden"
  );

}


/*==============================================================================
HELPERS
==============================================================================*/

function cleanString(value){

  if(
    value === null ||
    value === undefined
  ){

    return "";

  }


  return String(
    value
  ).trim();

}


function prefersReducedMotion(){

  return (
    window.matchMedia &&
    window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches
  );

}


/*==============================================================================
PUBLIC API
==============================================================================*/

window.TrestleLanding = {

  initialize,


  scrollTo(sectionId){

    const id =
      cleanString(
        sectionId
      )
      .replace(
        /^#/,
        ""
      );


    if(!id){
      return;
    }


    const target =
      document.getElementById(
        id
      );


    if(target){

      scrollToElement(
        target
      );

    }

  },


  closeAllFAQs(){

    const buttons =
      document.querySelectorAll(
        ".tr-landing-faq-question"
      );


    buttons.forEach(button => {

      const item =
        button.closest(
          ".tr-landing-faq-item"
      );


      if(!item){
        return;
      }


      const answer =
        item.querySelector(
          ".tr-landing-faq-answer"
        );


      if(answer){

        closeFAQ(
          button,
          answer
        );

      }

    });

  }

};


/*==============================================================================
BOOT
==============================================================================*/

if(
  document.readyState ===
  "loading"
){

  document.addEventListener(
    "DOMContentLoaded",
    initialize
  );

}

else{

  initialize();

}


/*==============================================================================
SHOPIFY THEME EDITOR SUPPORT
==============================================================================*/

document.addEventListener(
  "shopify:section:load",
  () => {

    State.initialized =
      false;


    initialize();

  }
);


/*==============================================================================
END
==============================================================================*/

})();